// import PropTypes from 'prop-types';

// const HeroSection = ({data}) => {
//   return (
//     <div className={'relative w-full md:h-[80vh] lg:h-screen'}>
//       {/* Background image */}
//       <img
//         src={data.image}
//         alt={'Hero Section'}
//         className={'w-full h-full object-cover'}
//       />

//       {/* Title */}
//       <div className={'absolute inset-0 flex justify-center items-start text-secondary-300 mt-14 md:mt-24 lg:mt-28 2xl:mt-52'}>
//         <h1 className={'text-lg md:text-4xl lg:text-5xl font-bold playfair-display-medium'}>
//           {data.title}
//         </h1>
//       </div>

//       {/* Title1 */}
//       <div className={'absolute inset-0 flex justify-center items-start text-secondary-300 mt-20 md:mt-32 lg:mt-40 2xl:mt-48'}>
//         <h1 className={'text-lg md:text-3xl lg:text-5xl font-bold playfair-display-medium'}>
//           {data.title1}
//         </h1>
//       </div>
//     </div>
//   );
// };

// HeroSection.propTypes = {
//   data: PropTypes.exact({
//     image: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//     title1: PropTypes.string.isRequired,
//   }).isRequired,
// };

// export default HeroSection;
import PropTypes from 'prop-types';

const HeroSection = ({data}) => {
  return (
    <div className={'w-full h-[40vh]  md:h-[73vh]'}> 
      <img src={data.image} alt={'herosection'} className={'w-full h-[40vh] md:h-[73vh] lg:pt-0 pt-5'}></img>
    </div>
  );
};

HeroSection.propTypes = {
  data: PropTypes.shape,
};

export default HeroSection;
